// TODO: very strange behaviour of onChange in _BasicField, need to rewrite it with formik array field
import classNames from 'classnames/bind';
import Button from 'mcs-toolkit/components/Button';
import Dropdown from 'mcs-toolkit/components/Dropdown';
import Input from 'mcs-toolkit/components/Input';
import React from 'react';
import { BackupsUtils } from 'services/backups/modules/BackupModule/BackupsUtils';

import IconTrash from 'reactApp/components/icons/trash';

import styles from './InputTrigger.css';

const css = classNames.bind(styles);

export class InputTrigger extends React.Component {
    render() {
        const { weekdays = [], hour = '', minute = '' } = this.props.value;
        const {
            disabled,
            onChange,
            onDelete,
            errorText,
            fieldsWithError = [],
            activeDeleteButton,
            onlyDays,
            multiple,
            minuteInputRef = () => {},
        } = this.props;

        const options = BackupsUtils.WEEKDAYS_OPTIONS.slice(onlyDays ? 1 : 0);

        return (
            <>
                <div className={css('triggerWrapper')}>
                    <Dropdown
                        id="weekdays"
                        fluid
                        multiple={multiple}
                        selection
                        className={css('weekdaysSelect')}
                        onChange={onChange}
                        value={multiple ? weekdays : weekdays[0]}
                        options={options}
                        disabled={disabled}
                        error={fieldsWithError.includes('weekdays')}
                    />
                    <span
                        className={css(
                            'label',
                            'hour',
                            this.props.disabled && 'disabled',
                        )}
                    >
                        Время
                    </span>
                    <Input
                        data-test="input-hour"
                        id="hour"
                        value={hour}
                        className={css('hourInput')}
                        onChange={onChange}
                        disabled={disabled}
                        error={fieldsWithError.includes('hour')}
                    />
                    <span
                        className={css(
                            'label',
                            'minute',
                            this.props.disabled && 'disabled',
                        )}
                    >
                        :
                    </span>
                    <Input
                        data-test="input-minute"
                        id="minute"
                        value={minute}
                        className={css('minuteInput')}
                        onChange={onChange}
                        disabled={disabled}
                        error={fieldsWithError.includes('minute')}
                        maxLength={2}
                        ref={minuteInputRef}
                    />
                    {activeDeleteButton && (
                        <Button
                            basic
                            icon
                            size="small"
                            className={css('button')}
                            onClick={onDelete}
                            disabled={disabled}
                            type="button"
                        >
                            <IconTrash />
                        </Button>
                    )}
                </div>
                <div className={css('errorWrapper')}>{errorText}</div>
            </>
        );
    }
}
